import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Question from '../structured-data/question';
import { Accordion, Row, Column, Collapse } from '@pella/sash-framework';
import { isValidArray } from '../../utilities/validations';

import styles from './index.module.scss';

const FAQ = ({ data, noStructuredData = false, getFAQData, multiple = false, isOpen = null, multipleColumns = false, className, layout, ...other }) => {
	useEffect(() => {
		if (typeof getFAQData === 'function' && isValidArray(data)) {
			getFAQData(data);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- preexisting failure, fix when possible
	}, []);

	if (!isValidArray(data)) return null;

	return (
		<>
			{!multipleColumns && (
				<Accordion
					className={`faqList !border-0 ${styles.faqList} ${className || ''}`}
					allowMultiple={multiple}
					layout={layout}
					defaultOpen={isOpen}
					{...other}
				>
					{isValidArray(data) &&
						data.map((faq, index) => (
							<Accordion.Item
								key={index}
								value={`item-${index}`}
								className='border-b border-t-0 !border-gray-15'
							>
								<Accordion.Trigger className='!px-0 !py-4'>
									<div
										{...(faq.$?.question ?? {})}
										className='faqQuestion'
										dangerouslySetInnerHTML={{ __html: faq.question }}
									/>
								</Accordion.Trigger>

								<Accordion.Content className='!px-0'>
									<div
										{...(faq.$?.answer ?? {})}
										className='faqAnswer'
										dangerouslySetInnerHTML={{ __html: faq.answer }}
									/>
								</Accordion.Content>
							</Accordion.Item>
						))}
				</Accordion>
			)}

			{multipleColumns && (
				<Row className={`faqList-multi ${styles.faqList_multiColumn} md:!-mx-5 md:[&>*]:!px-5 ${className || ''}`}>
					{Array(2)
						.fill()
						.map((_, index) => (
							<Column
								xs={12}
								xl={6}
								key={index}
							>
								{data
									.filter((_, childIndex) => (index === 0 ? childIndex % 2 === 0 : childIndex % 2 !== 0))
									.map((faq, index) => (
										<Collapse key={index}>
											<Collapse.Trigger className='border-b-black'>
												<div
													{...(faq.$?.question ?? {})}
													className='faqQuestion'
													dangerouslySetInnerHTML={{ __html: faq.question }}
												/>
											</Collapse.Trigger>
											<Collapse.Content>
												<div
													{...(faq.$?.answer ?? {})}
													className='faqAnswer px-2'
													dangerouslySetInnerHTML={{ __html: faq.answer }}
												/>
											</Collapse.Content>
										</Collapse>
									))}
							</Column>
						))}
				</Row>
			)}

			{!noStructuredData && <Question faq={data} />}
		</>
	);
};

FAQ.propTypes = {
	data: PropTypes.array,
	noStructuredData: PropTypes.bool,
	getFAQData: PropTypes.func,
	multiple: PropTypes.bool,
	isOpen: PropTypes.number,
	multipleColumns: PropTypes.bool,
	className: PropTypes.string,
	layout: PropTypes.string,
};

export default FAQ;
